module.exports = __webpack_public_path__ + "static/media/wallet.54009053.svg";